import { queryOptions } from "@tanstack/react-query";

import clientSDK from "~/api/clientSDK";
import { userToInternalUser } from "~/api/user/userToInternalUser";
import { DEFAULT_CACHE_TIME } from "~/constants";

import { userQueryKeys } from "./user-query-keys";

export const userQueryOptions = {
  all: () =>
    queryOptions({
      queryKey: userQueryKeys.all,
      queryFn: () =>
        clientSDK.listUsers("active", "human").catch((err: Error) => {
          throw new Error("An error occurred while loading user list ", err);
        }),
      staleTime: DEFAULT_CACHE_TIME,
      refetchOnWindowFocus: false,
    }),
  byId: (id: string) =>
    queryOptions({
      queryKey: userQueryKeys.byId(id),
      queryFn: () => clientSDK.getUserById(id),
      select: userToInternalUser,
      staleTime: DEFAULT_CACHE_TIME,
    }),
};
